import { TB_PLAN_DETAILS_API } from "../../../../constants/APIs";
import { Actions } from "../../../../store/actions";
import { TB_API } from "../../../../utils/utility/API-call";
import { handleError } from "../../../../utils/utility/snackbar";
import { dispatch } from "../../../../utils/utility/store";
import { navTabsTBDTO } from "../../dtos/navigationTabsDTO";

export const getPlansData = () => {
  TB_API()
    .get(TB_PLAN_DETAILS_API)
    .then((res) => {
      if (res.data.data) {
        dispatch(
          Actions.TBUser.SetNavTabs,
          navTabsTBDTO(res?.data?.data?.proptechTabsAssigned)
        );
        dispatch(Actions.TBUser.SetActivePlan, res?.data?.data?.tbPlanDetails);
        dispatch(Actions.TBUser.SetCountDetails, res?.data?.data);
      }
      if (res?.data?.code !== 200) {
        handleError(res?.data);
      }
    })
    .catch((err) => {
      handleError(err);
    });
};
